import Vue from "vue";
import pick from "lodash/pick";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";

// Add a rule.
extend("domain", {
  validate: (value, args) => {
    const regex = new RegExp(`@(${args.join("|")})$`);
    return regex.test(value);
  },
  message: (value, args) => {
    const domains = pick(
      args,
      Object.keys(args).filter(k => !k.includes("_"))
    );
    return `El correo electrónico debe ser de la agencia ${Object.values(
      domains
    ).join(" o ")}`;
  }
});

extend("nodomain", {
  validate: (value, args) => {
    const regex = new RegExp(`@(${args.join("|")})$`);
    return !regex.test(value);
  },
  message: (value, args) => {
    const domains = pick(
      args,
      Object.keys(args).filter(k => !k.includes("_"))
    );
    return `El correo electrónico no debe ser de la agencia ${Object.values(
      domains
    ).join(" o ")}`;
  }
});
extend("greaterThanZero", value => {
  if (!isNaN(value) && value > 0) return true;
  return "El número de intervenciones debe ser mayor a 0.";
});
extend("differentFromZero", value => {
  if (!isNaN(value) && value != 0) return true;
  return "Favor de añadir un valor diferente de cero";
});

extend("completePhone", value => {
  if (value != null) {
    let phoneNumber = value
      .toString()
      .replace(/\D/g, "")
      .toString();
    if (phoneNumber.length < 10 && phoneNumber.length != 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
});

extend("studentSie", value => {
  const str = value.toString();
  if (!isNaN(value) && value && str.length === 8) return true;
  return "El número de SIE no es correcto.";
});

extend("completePersonalssn", value => {
  if (value == null || value === "") return true;
  const ssn = String(value).replace(/\D/g, "");
  if (ssn.length === 0) return true;
  if (ssn.length < 9) {
    return "El número de Seguro Social debe ser correcto.";
  }
  return true;
});

extend("markCheckbox", value => Boolean(value));

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
